import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Quill from 'quill';

// Obtener el módulo Link de Quill
const Link = Quill.import('formats/link');

// Sobrescribir el método `sanitize` para agregar target y rel
Link.sanitize = function (url) {
  const sanitizedUrl = Quill.import('formats/link').sanitize(url);
  return sanitizedUrl;
};

// Extender el formato para forzar target="_blank"
Link.formats = function (domNode) {
  return {
    href: domNode.getAttribute('href'),
    target: '_blank',
    rel: 'noopener noreferrer',
  };
};

Quill.register(Link, true);

export default function EditorForm({
  id,
  onChange,
  initialValue,
  label,
  spam,
  cols,
}) {

  const customColors = [
    '#000000', '#2e6a82', '#ffffff', '#f59e0b','#06c'
  ];

  const fonts = ['BloomingHeart', 'Arial', 'Courier New', 'Georgia', 'Times New Roman', 'Verdana'];

  const modules = {
    toolbar: [
      [{ 'header': '1' }, { 'header': '2' }, { 'font': fonts.map(font => font) }],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'color': customColors }, { 'background': customColors }], // Custom colors
      [{ 'align': [] }], // 👈 Esto habilita la justificación de texto
      ['link'], // <-- Agrega esta línea para el botón de enlace
    ],
  };

  const formats = [
    'header', 'font', 'list', 'bullet', 'bold', 'italic', 'underline', 'strike', 'blockquote',
    'color', 'background', 'align',// Add color and background formats
    'link', // <-- Agrega esto también para habilitar el formato link
  ];

  return (
    <div
      className={`flex text-start flex-col w-full cols  cols-${!cols || cols === 1 ? '1' : cols
        }`}
    >
      <label className="text-sm flex items-center m-1 font-semibold">
        <p>{label}</p>
        {spam === true && <span className="text-red-500">*</span>}
      </label>
      <div className='flex w-full h-full p-2'>
        <ReactQuill
          modules={modules}
          formats={formats}
          value={initialValue}
          onChange={onChange}
          className='w-full h-full outline-none input-bordered focus:outline-none focus:ring-1 bg-slate-100 textarea contenedor rounded-md shadow-gray-300 shadow-lg' />
      </div>
    </div>
  );
}
